import Model from '../../ModelBinding/Model';
import dayjs from 'dayjs';
import MissionMediaCollection from './MissionMediaCollection';
import MissionMediaFileCollection from '../MissionMediaFile/MissionMediaFileCollection';
import ReasonCollection from '../Reason/ReasonCollection';
import MissionEventCollection from '../MissionEvent/MissionEventCollection';
import MissionMediaStatus from '../MissionMediaStatus/MissionMediaStatus';
import MissionMediaMetaCollection from '../MissionMediaMeta/MissionMediaMetaCollection';

export default class MissionMedia extends Model {
  static rootUri = 'mission-media';

  public current_status?: string;
  public filename?: string;
  public is_original_filename?: boolean;
  public offer_item_id?: string;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public files?: MissionMediaFileCollection;
  public reasons?: ReasonCollection;
  public events?: MissionEventCollection;
  public sort?: Number;
  public status?: MissionMediaStatus;
  public metas?: MissionMediaMetaCollection;

  bind() {
    this.current_status = this.getStringAttribute('current_status');
    this.filename = this.getStringAttribute('filename');
    this.is_original_filename = this.getBooleanAttribute('is_original_filename');
    this.offer_item_id = this.getStringAttribute('offer_item_id');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.files = this.getRelationCollection(
      'files',
      MissionMediaFileCollection,
    ) as MissionMediaFileCollection;
    this.reasons = this.getRelationCollection('reasons', ReasonCollection) as ReasonCollection;
    this.events = this.getRelationCollection(
      'events',
      MissionEventCollection,
    ) as MissionEventCollection;
    this.sort = this.getIntAttribute('sort');
    this.status = this.getRelation('status', MissionMediaStatus) as MissionMediaStatus;
    this.metas = this.getRelationCollection('metas', MissionMediaMetaCollection) as MissionMediaMetaCollection;
  }

  static getCollection() {
    return MissionMediaCollection;
  }

  canBeSetAside():Boolean {
    if (!this.current_status) return false;
    return !!(this.status && this.status.events && this.status.events.some(({ id })=> id === 'MWA:ASIDE'));
  }

  canBeRejected():Boolean {
    if (!this.current_status) return false;
    return !!(this.status && this.status.events && this.status.events.some(({ id })=> id === 'MWA:REFUSED'));
  }

  canBePostQC():Boolean {
    if (!this.current_status) return false;
    return !!(this.status && this.status.events && this.status.events.some(({ id })=> id === 'MWA:POST_QC'));
  }

  canBeWaitingEdition():Boolean {
    if (!this.current_status) return false;
    return !!(this.status && this.status.events && this.status.events.some(({ id })=> id === 'MWA:WAITING_EDITION'));
  }

  canBePreQC():Boolean {
    if (!this.current_status) return false;
    return !!(this.status && this.status.events && this.status.events.some(({ id })=> id === 'MWA:PRE_QC'));
  }

  canBeUnsetAside():Boolean {
    if (!this.current_status) return false;
    return !!(this.status && this.status.events && this.status.events.some(({ id })=> id === 'MWA:UNSET_ASIDE'));
  }

  canHaveFeedback():Boolean {
    if (!this.current_status) return false;
    return !!(this.status && this.status.events && this.status.events.some(({ id })=> id === 'MWA:FEEDBACK_EDITION'))
  }
}
